export default "__VITE_ASSET__98efbb86__"